import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import store from './store'
import Stamp from './static/stamp'
import VueCryptojs from 'vue-cryptojs'

Vue.config.productionTip = false
Vue.prototype.$stamp = new Stamp();
Vue.use(VueCryptojs)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
